import { render, staticRenderFns } from "./CleaningTypeList.vue?vue&type=template&id=59344f90"
import script from "./CleaningTypeList.vue?vue&type=script&lang=js"
export * from "./CleaningTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports